function buildRequiredFieldsByService(services) {
  function mergeRequiredFields(service) {
    const service_required_fields = Array.isArray(service?.required_fields) ? service.required_fields : [];
    const system_verification_fields = Array.isArray(service?.system_verification_fields)
      ? service.system_verification_fields
      : [];
    const merged = [...service_required_fields, ...system_verification_fields];
    const seen = new Set();

    return merged.filter((field) => {
      const key = String(field?.key || field?.name || field || '').trim();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  const required_by_service = {};
  services.forEach((service) => {
    Reflect.set(
      required_by_service,
      String(service?.id),
      mergeRequiredFields(service),
    );
  });
  return required_by_service;
}

export function normalizeVerificationGuidance(services_data) {
  const services = Array.isArray(services_data?.data) ? services_data.data : [];
  const services_guidance = {
    required_by_service: buildRequiredFieldsByService(services),
    services,
  };
  return services_guidance;
}

export function applyVerificationGuidanceState(ctx, services, required_by_service) {
  ctx.verification_services = services;
  ctx.verification_required_fields_by_service = required_by_service;

  if (!ctx.verification_active_service_id && services.length) {
    ctx.verification_active_service_id = String(services[0].id);
  }
}

export function resetVerificationGuidanceState(ctx) {
  ctx.verification_services = [];
  ctx.verification_required_fields_by_service = {};
}
